import { render, staticRenderFns } from "./DangerOccur.vue?vue&type=template&id=5f8f1ac3&"
import script from "./DangerOccur.vue?vue&type=script&lang=js&"
export * from "./DangerOccur.vue?vue&type=script&lang=js&"
import style0 from "./DangerOccur.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_dev\\workspace_front\\aikl_v2_front_kcc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f8f1ac3')) {
      api.createRecord('5f8f1ac3', component.options)
    } else {
      api.reload('5f8f1ac3', component.options)
    }
    module.hot.accept("./DangerOccur.vue?vue&type=template&id=5f8f1ac3&", function () {
      api.rerender('5f8f1ac3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/biz/DangerOccur.vue"
export default component.exports